export function ShieldTickIcon() {
  return (
    <svg
      fill="none"
      height="12"
      viewBox="0 0 12 12"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 5.74994L5.5 6.74994L7.75 4.49994M10 5.99994C10 8.45416 7.32302 10.2391 6.349 10.8074C6.2383 10.872 6.18295 10.9042 6.10484 10.921C6.04422 10.934 5.95578 10.934 5.89516 10.921C5.81705 10.9042 5.7617 10.872 5.65101 10.8074C4.67698 10.2391 2 8.45416 2 5.99994V3.60874C2 3.20898 2 3.0091 2.06538 2.83729C2.12314 2.68551 2.21699 2.55007 2.33883 2.4427C2.47675 2.32115 2.6639 2.25097 3.0382 2.11061L5.7191 1.10527C5.82305 1.06629 5.87502 1.0468 5.92849 1.03908C5.97592 1.03222 6.02408 1.03222 6.07151 1.03908C6.12498 1.0468 6.17695 1.06629 6.2809 1.10527L8.9618 2.11061C9.3361 2.25097 9.52325 2.32115 9.66117 2.4427C9.78301 2.55007 9.87686 2.68551 9.93462 2.83729C10 3.0091 10 3.20898 10 3.60874V5.99994Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
